export const NEXTORE_URL = '/nextore';
